export const extractFirstName = (name?: string) =>
  name?.split(',')[1]?.split(' ')[1] || '';

export const isCuroName = (name?: string) =>
  typeof name === 'string' && name.includes(',');

export const shortenName = (name?: string) =>
  isCuroName(name) ? extractFirstName(name) : name;
